module.exports = __webpack_public_path__ + "static/media/temple.26ed1b6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temple.png
// module id = 621
// module chunks = 0